import {getPricing} from '../../vue/utility/api/open/getPricing';

var skPricingApp = new Vue({
  el: '#pricing-page',
  data() {
    return {
      chargebee: window.SK_CHARGEBEE_ENABLED,
      checkout: /checkout/.test(window.location.search),
      defaults: window.SK_PRICING_DEFAULTS || {},
      discount: 0,
      monthly: false,
      pricing: {},
    };
  },
  computed: {
    corePerMonth() {
      return this.monthly ? this.corePerMonthMonthly : this.corePerMonthYearly;
    },
    corePerMonthMonthly() {
      return (this.chargebee ? this.pricing['CMM2M']?.price / 100 : this.defaults.corePerMonthMonthly) || 245;
    },
    corePerMonthYearly() {
      return (this.chargebee ? this.pricing['CM12M']?.price / 100 : this.defaults.corePerMonthYearly) || 225;
    },
    coreSetupFee() {
      return this.monthly ? this.coreSetupFeeMonthly : this.coreSetupFeeYearly;
    },
    coreSetupFeeMonthly() {
      return (this.chargebee ? this.pricing['CMM2MSUF']?.price / 100 : this.defaults.coreSetupFeeMonthly) || 489;
    },
    coreSetupFeeYearly() {
      return (this.chargebee ? 0 : this.defaults.coreSetupFeeYearly) || 0;
    },
    monthlyPrice() {
      return this.formatPrice(
          this.applyDiscount(this.corePerMonth)
      );
    },
    setupFee() {
      return this.formatPrice(this.coreSetupFee);
    },
    checkoutUrl() {
      if (this.chargebee) {
        const cartCode = this.monthly ? 'CMM2M' : 'CM12M';
        const loggedIn = document.body.classList.contains('logged-in');

        return loggedIn ? `/payment?c=${cartCode}` : `/register?c=${cartCode}`;
      } else {
        return '/add-' + (this.monthly ? 'm2m' : '12m');
      }
    },
  },
  methods: {
    onMonthlyClick() {
      this.monthly = true;
    },
    onYearlyClick() {
      this.monthly = false;
    },
    onDiscountInput(event) {
      this.discount = Number(event.target.value) || 0;
    },
    applyDiscount(price) {
      const discount = this.discount < 100 ? this.discount : 100;
      return Math.round(((100 - discount) / 100) * price);
    },
    formatPrice(price) {
      return Math.round(price).toLocaleString('en-US');
    },
  },
  async mounted() {
    if (this.chargebee) {
      this.pricing = await getPricing();
    }
  },
});
